import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HeroBannerContextType {
  hasHeroBanner: boolean;
  setHasHeroBanner: (has: boolean) => void;
}

const HeroBannerContext = createContext<HeroBannerContextType | undefined>(undefined);

export const HeroBannerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [hasHeroBanner, setHasHeroBanner] = useState(false);

  return (
    <HeroBannerContext.Provider value={{ hasHeroBanner, setHasHeroBanner }}>
      {children}
    </HeroBannerContext.Provider>
  );
};

export const useHeroBanner = () => {
  const context = useContext(HeroBannerContext);
  if (context === undefined) {
    throw new Error('useHeroBanner must be used within a HeroBannerProvider');
  }
  return context;
};

